export const TRANSPORTS: ("websocket" | "polling")[] = ["websocket", "polling"];

export const LAN_ONLY_ICE_SERVERS: RTCIceServer[] = [];

export const FRIENDLY_ERROR_MESSAGE =
  "Connection failed. Confirm both devices are on the same Wi-Fi network, then try again.";

export const NETWORK_DROP_MESSAGE =
  "Network connection lost. Move both devices onto the same Wi-Fi and reconnect when ready.";

export const REMOTE_ERROR_EVENT = "peer-connection:error";
export const REMOTE_TERMINATED_EVENT = "peer-connection:terminated";

export type PeerDeviceRole = "laptop" | "mobile";

export type PeerStatus =
  | "idle"
  | "preparing"
  | "waiting-for-offer"
  | "creating-offer"
  | "signaling"
  | "connecting"
  | "connected"
  | "closed"
  | "error";

export interface StartPeerConnectionOptions {
  initiator: boolean;
  stream?: MediaStream | null;
}

export type ClearPeerOptions = {
  destroyLocalStream?: boolean;
  nextStatus?: PeerStatus;
  nextError?: string | null;
};

export type ClearSocketOptions = {
  disconnect?: boolean;
};

export const resolveCounterpartRole = (role: PeerDeviceRole): PeerDeviceRole =>
  role === "laptop" ? "mobile" : "laptop";

export const derivePeerRoom = (peerConnectionId: string, role: PeerDeviceRole) =>
  `${peerConnectionId}-${role}`;

export const resolveSocketUrl = (): string | null => {
  if (typeof window === "undefined") {
    return null;
  }

  declare const __BACKEND_URL__: string | undefined;

  const envUrl = "https://interview.1.2.employability.ai"
  try {
    const parsed = new URL(envUrl);
    // Socket.IO client expects HTTP/HTTPS URLs, not WS/WSS
    // It handles the WebSocket upgrade internally
    return parsed.toString();
  } catch (error) {
    console.error("[PeerConnectionManager] Failed to parse BACKEND_URL", error);
    return null;
  }
};
